module.exports = __webpack_public_path__ + "img/bj_0.eb425317.jpg";